import React from "react";

function PaymentsReport({ paymentsReport }) {
  const months = [
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
  ];
  return (
    <div>
      <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
        {/* Table Head  */}
        <thead>
          <tr className="bg-gray-100">
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
              Sl No
            </th>
            <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
              Building Name
            </th>
            {months.map((month) =>
              ["Rent", "Electricity", "Dues"].map((sub) => (
                <th
                  key={month + sub}
                  className={`py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColors ${
                    month === "March" && sub === "Dues" ? "rounded-r-xl" : ""
                  }`}
                >
                  {month} - {sub}
                </th>
              ))
            )}
          </tr>
        </thead>

        {/* Table Body  */}
        <tbody>
          {paymentsReport?.length > 0 ? (
            paymentsReport?.map((data, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-50"
              >
                <td className="py-4 px-6 ext-sm text-primaryTextColor">
                  {index + 1}
                </td>
                <td className="border p-2 font-semibold text-left">
                  {data.buildingName}
                </td>
                {months.map((month) =>
                  [
                    "totalRentCollected",
                    "totalElectricityCollected",
                    "totalDuesCollected",
                  ].map((key) => (
                    <td
                      key={month + key}
                      className="border p-2 font-semibold text-left"
                    >
                      {data.monthlyPayments[month]?.[key] || 0}
                    </td>
                  ))
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={38}
                className="py-40 px-6 text-lg text-center text-secondaryTextColor"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default PaymentsReport;
